import { render, staticRenderFns } from "./MrnMsn.vue?vue&type=template&id=8ad37a62&scoped=true"
import script from "./MrnMsn.vue?vue&type=script&lang=js"
export * from "./MrnMsn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad37a62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ad37a62')) {
      api.createRecord('8ad37a62', component.options)
    } else {
      api.reload('8ad37a62', component.options)
    }
    module.hot.accept("./MrnMsn.vue?vue&type=template&id=8ad37a62&scoped=true", function () {
      api.rerender('8ad37a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/MrnMsn.vue"
export default component.exports